import { render, staticRenderFns } from "./DeleteUserVipPlanConfirmationDialog.vue?vue&type=template&id=4cefd520"
import script from "./DeleteUserVipPlanConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteUserVipPlanConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports